module.exports = __webpack_public_path__ + "img/old.68598817.png";